<link href="//vjs.zencdn.net/5.4.6/video-js.min.css" rel="stylesheet">
<script src='https://vjs.zencdn.net/7.6.0/video.js'></script>

<ng-container *ngIf="course">
  <div id="vjsparent">
    <video id="videojs" class="video-js vjs-default-skin vjs-big-play-centered" controls preload="auto"
      poster="{{course.splash_image_url}}" data-setup='{"fluid": true}'>
      <source src="{{course.content_url}}"
        [attr.type]="course.content_url.endsWith('m3u8') ? 'application/x-mpegURL' : undefined" />
      <source *ngIf="course.fallback_content_url" src="{{course.fallback_content_url}}" />
    </video>
  </div>
  <em *ngIf="!videoIsSeekable">You may pause or rewind the video at any time. You may not fast forward through the
    course.</em>
  <fa-icon id="stepback" class="d-none" [icon]="['fas','undo']"></fa-icon>
</ng-container>

<ng-container *ngIf="videourl">
  <video id="videojs" class="video-js vjs-default-skin vjs-big-play-centered" controls preload="auto"
    poster="{{splashurl}}" data-setup='{"fluid": true}'>
    <source src="{{videourl}}">
  </video>
</ng-container>